<template>
  <section class="content" style="background-color: #EBECF1">
    <div class="row">
      <div class="col-md-12">
        <div class="box box-info">
          <div class="box-header">
            <h3 class="fuente box-title p-t-10">MANTENIMIENTO DE ÁREAS</h3>
          </div>
          <div class="box-body">
            <form role="form">
              <div class="box-footer" style="padding-left:15px;">
                <button type="button" class="fuente btn btn-primary fs-13" @click="limpiar()" data-toggle="modal"
                  data-target="#modalNuevo">Nuevo Registro</button>
              </div>
              <div class="row">
                <div class="fuente col-xs-12 table-responsive">
                  <div class="box-body">
                    <table aria-describedby="tablaDetalle_info" role="grid" id="tablaDetalle"
                      class="fuente fs-12 table table-bordered table-striped dataTable">
                      <thead>
                        <tr role="row">
                          <th aria-label="ITEM" aria-sort="ascending" aria-controls="tablaDetalle" tabindex="0"
                            class="sorting_asc">ITEM</th>
                          <th aria-label="DESCRIPCIÓN" aria-sort="ascending" aria-controls="tablaDetalle" tabindex="0"
                            class="sorting_asc">DESCRIPCIÓN</th>
                          <th aria-label="URL" aria-controls="tablaDetalle" tabindex="0" class="sorting">TIPO</th>
                          <th aria-label="SIGLA" aria-controls="tablaDetalle" tabindex="0" class="sorting">SIGLA</th>
                          <th aria-label="REPRESENTANTE" aria-controls="tablaDetalle" tabindex="0" class="sorting">
                            REPRESENTANTE</th>
                          <th aria-label="MODIFICAR" aria-controls="tablaDetalle" tabindex="0"
                            class="sorting table-center-header">MODIFICAR
                          </th>
                          <th aria-label="DETALLE" aria-controls="tablaDetalle" tabindex="0"
                            class="sorting table-center-header">DETALLE</th>
                          <th aria-label="ANULAR" aria-controls="tablaDetalle" tabindex="0"
                            class="sorting table-center-header">ANULAR</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr class="even" role="row" v-for="item in areas">
                          <td class="sorting_1">{{ item.cont }}</td>
                          <td>{{ item.descripcion }}</td>
                          <td>{{ item.tipo }}</td>
                          <td>{{ item.sigla }}</td>
                          <td>{{ item.nombres }} {{ item.apePaterno }} {{ item.apeMaterno }}</td>
                          <td class="table-center-header"><span style="cursor:pointer" class="badge bg-blue"
                              data-toggle="modal" @click="ver(item)" data-target="#modalNuevo">O</span>
                          </td>
                          <td class="table-center-header">
                            <router-link
                              :to="{ name: 'area_detalle' /*, params: { idArea: item.idArea, descripcionArea: item.descripcion }*/ }">
                              <span @click="enviar(item)" style="cursor:pointer"
                                class="badge bg-yellow">
                                <!--<span style="cursor:pointer" class="badge bg-yellow">-->
                                V
                              </span>
                            </router-link>
                          </td>
                          <td class="table-center-header"><span style="cursor:pointer" class="badge bg-red"
                              data-toggle="modal" @click="verAnular(item)" data-target="#modalAnular">X</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="fuente col-md-12" style="color: red;">
                    {{ error.desError }}
                  </div>
                </div>
              </div>
              <div class="modal fade" id="modalNuevo" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
                <div class="modal-dialog" role="document">
                  <div class="modal-content">
                    <form>
                      <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
                            aria-hidden="true">X</span></button>
                        <h4 class="fuente modal-title m-t-10" id="myModalLabel">{{ texto }}</h4>
                      </div>
                      <div class="fuente modal-body fs-12">
                        Descripción:<br />
                        <input type="text" class="form-control m-t-10" id="descripcion" v-model="area.descripcion"
                          @input="handleDescripcionInput" /><br />
                        Tipo:<br />
                        <select class="form-control m-t-10" v-model="area.tipo">
                          <option value="C">COMISIÓN</option>
                          <option value="M">DESPACHO DE MAGISTRADO</option>
                          <option value="T">TRIBUNAL</option>
                          <option value="X">X</option>
                        </select>
                        <br />
                        Sigla:<br />
                        <input type="text" class="form-control m-t-10" id="sigla" v-model="area.sigla"
                          @input="handleSiglaInput" :disabled="isEditMode" />
                        <small class="text-danger">{{ mensajeLimiteSigla }}</small><br />
                        <div class="representante-container">
                          <span class="representante-label">Representante:</span><br />
                          <!--- Se filtra y muestra todos los usuarios en el combobox con campo de búsqueda-->
                          <v-select v-model="selectedIdPersonal" :options="filteredUsuarios" :filterable="true"
                            label="nombreCompleto" @input="selectPersonal"
                            class="fuente form-control m-t-10 m-b-10 combobox-personalizado2" placeholder="Seleccionar"
                            style="padding: 0px; border-style: hidden;">
                            <template v-slot:no-options="{ search }">
                              Lo siento, no hay usuarios que coincidan con "{{ search }}".
                            </template>
                          </v-select>
                        </div>
                      </div>
                      <div class="modal-footer">
                        <button type="button" class="fuente btn btn-primary fs-13" @click="merge()" data-dismiss="modal"
                          :disabled="!area.descripcion || !area.sigla || area.idRepresenta == '0'"
                          :title="(!area.descripcion || !area.sigla || area.idRepresenta == '0') ? 'Para guardar, complete todos los campos' : ''">
                          Guardar Cambios</button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <div class="modal fade" id="modalAnular" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
                <div class="modal-dialog" role="document">
                  <div class="modal-content">
                    <form>
                      <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
                            aria-hidden="true">X</span></button>
                        <h4 class="fuente modal-title m-t-10" id="myModalLabel">ANULAR ÁREA</h4>
                      </div>
                      <div class="fuente modal-body">
                        Se anulará el área {{ area.descripcion }} <br />
                      </div>
                      <div class="modal-footer">
                        <button type="button" class="fuente btn btn-danger fs-13" @click="merge()"
                          data-dismiss="modal">Anular Área</button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

import 'datatables.net'
import 'datatables.net-bs'
import axios from 'axios'
import $ from 'jquery'
import { apiURL, apiLOGIN } from '@/store/state' //llamando al apiURL del store
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
//import App from '../App.vue';
import App from '@/components/App.vue';
import moment from 'moment';

export default {
  name: 'Tables',
  data() {
    return {
      areas: [],
      usuByArea: [], /// Guarda todos los usuarios según el idArea
      array: [], /// Almacenar cada areaxusuario a anular
      texto: '',
      error: {
        desError: ''
      },
      error2: {
        desError: ''
      },
      error3: {
        desError: ''
      },
      area: {
        idArea: '0',
        descripcion: '',
        tipo: 'C',
        sigla: '',
        idRepresenta: '0',
        idPersona: '0',
        nombres: '',
        apePaterno: '',
        apeMaterno: '',
        flagActivo: '1',
        usuario: this.$session.get('user')
      },
      isEditMode: true, ///Deshabilitar el modo edición en el campo Sigla del modalNuevo
      mensajeLimiteSigla: '', //Mensaje al exceder límite de caracteres en la campo Sigla del modal
      usuarios: [],
      selectedIdPersonal: null,
      searchText: '',
      usuarioSeleccionado: {},
      tiempoActual: null,
      tiempoTokenExp: null,
    }
  },
  components: {
    vSelect
  },
  mounted() {
    //this.tiempoActual = new Date().toLocaleString('es-PE', { timeZone: 'America/Lima' });
    //this.tiempoTokenExp = localStorage.getItem('TokenExpirationTime')
    this.tiempoActual = moment(new Date().toLocaleString('es-PE', { timeZone: 'America/Lima' }), "D/M/YYYY, h:mm:ss a"); 
    this.tiempoTokenExp = moment(localStorage.getItem('TokenExpirationTime'), "D/M/YYYY, h:mm:ss a");
    

    // Verificar la sesión token
    if (!this.$session.exists('token')) {
      App.methods.logout.call(this);
      return;
    }

    if (this.tiempoActual < this.tiempoTokenExp) {
      axios.defaults.headers.common['Authorization'] = this.$session.get('token')
      // Realizar la validación con la API
      axios.get(`${apiLOGIN}/operaciones/app/GESU/areas`)
        .then(response => {
          if (response.data.codError === 1 || response.data.desError === 'ok') {
            // La validación es exitosa, continuar con la carga de datos
            this.carga();
          } else {
            //console.log("Usuario No Autorizado")
            //this.$router.go(-1);
            this.alertaError();
          }
        })
        .catch(error => {
          if (error.response && error.response.status === 401) {
            // Manejar el caso de error de autorización
            this.alertaError401();
          } else if (error.response && error.response.status === 403) {
            //this.$router.go(-1);
            this.alertaError();
          } else if (error.response && error.response.status === 500) {
            //this.$router.go(-1);
            this.alertaError500();
          } else {
            //this.$router.go(-1);
            this.alertaError401();
          }
        });
    } else {
      this.alertaError401();
    }
  },
  methods: {
    //Cargar datos a la DataTable
    carga() {
      // Destruir la instancia DataTable si ya existe
      const dataTableInstance = $('#tablaDetalle').DataTable();
      if (dataTableInstance) {
        dataTableInstance.destroy();
      }

      axios.get(
        //'https://tomcat.sedetc.gob.pe/cas-services-0.0.2/operaciones/area/*'
        `${apiURL}/operaciones/area/*`
      ).then(response => {
        this.areas = response.data

        this.$nextTick(() => {
          $('#tablaDetalle').DataTable({
            stateSave: true,
            'stateSaveParams': function (settings, data) {
              data.length = 25; // Establece la longitud de la página
            },
            pageLength: 25,
            'oLanguage': {
              'sSearch': 'Buscar',
              'sInfo': 'Mostrando _START_ al _END_ de _TOTAL_ registros',
              'sEmptyTable': 'Sin Data',
              'ZeroRecords': 'No se encontraron coincidencias',
              'sInfoFiltered': '(filtrado de un total de _MAX_ registros)',
              'sLengthMenu': '_MENU_ Registros por pagina',
              'oPaginate': {
                'sPrevious': 'Anterior',
                'sNext': 'Siguiente'
              }
            }
          })
        })
      })
        .catch(error => {
          if (error.response.status === 401) {
            App.methods.logout.call(this);
          }
        })
    },
    merge: function () {
      if (moment(new Date().toLocaleString('es-PE', { timeZone: 'America/Lima' }), "D/M/YYYY, h:mm:ss a") < this.tiempoTokenExp) {
        axios.post(
          //'https://tomcat.sedetc.gob.pe/cas-services-0.0.2/operaciones/area/add',
          `${apiURL}/operaciones/area/add`,
          {
            'idArea': this.area.idArea,
            'descripcion': this.area.descripcion,
            'tipo': this.area.tipo,
            'sigla': this.area.sigla,
            'idRepresenta': this.area.idRepresenta,
            'flagActivo': this.area.flagActivo,
            'usuario': this.$session.get('user')
          }
        ).then(response => {
          this.error = response.data

          ////Solo si se anulo el Área (flagActivo == '0'), buscar todos sus areaxusuario y anular cada uno
          if (this.area.flagActivo == '0') {
            ///Obtener todos sus areaxusuario según el this.area.idArea
            axios.get(
              `${apiURL}/usuarios/personas/` + this.area.idArea
            ).then(response => {
              this.usuByArea = response.data
              //// si usuByArea no está vacio, realizar un forEach y anular cada array obtenido de usuByArea
              if (this.usuByArea.length !== 0) {
                this.usuByArea.forEach((array) => {
                  //// Método para anular cada areaxusuario relacionada a esta idArea
                  this.anularUsuByArea(array);
                })
              }
            })
              .catch(error => {
                if (error.response && error.response.status === 401) {
                  App.methods.logout.call(this);
                }
              })
          }
          /// Recargar la tabla al finalizar 
          this.carga();
        })
          .catch(error => {
            if (error.response.status === 401) {
              App.methods.logout.call(this);
            }
          })
      } else {
        this.alertaError401();
      }
    },
    ver: function (area) {
      this.texto = 'ACTUALIZAR LOS DATOS DEL ÁREA'
      this.area = { ...area }
      //console.log('..this.area', this.area)
      this.isEditMode = false; // Habilitar el modo de edición en el campo Sigla
      this.mensajeLimiteSigla = '';
      this.cargarUsuarios(); //// Cargar usuarios en el combobox del modal
      this.error.desError = ''

      //// Capturar el nombre completo del Representante de la tabla al combobox del modal
      this.selectedIdPersonal = `${area.nombres} ${area.apePaterno} ${area.apeMaterno}`;
      //console.log('selectedIdPersonal', this.selectedIdPersonal)
    },
    verAnular: function (area) {
      this.area = { ...area }
      this.area.flagActivo = '0'
      this.error.desError = ''
    },
    limpiar: function () {
      //console.log('this.area', this.area)

      this.cargarUsuarios(); ///Cargar usuarios en el combobox del modal
      this.selectedIdPersonal = null;
      this.usuarioSeleccionado = {
        idTrabajador: '0',
        nombres: '',
        apePaterno: '',
        apeMaterno: '',
      };
      this.error.desError = ''

      axios.get(
        //'https://tomcat.sedetc.gob.pe/cas-services-0.0.2/operaciones/area/*'
        `${apiURL}/operaciones/area/*`
      ).then(response => {
        this.areas = response.data
      })
        .catch(error => {
          if (error.response.status === 401) {
            App.methods.logout.call(this);
          }
        })

      this.texto = 'REGISTRAR UNA NUEVA ÁREA'
      this.area.idArea = '0'
      this.area.descripcion = ''
      this.area.tipo = 'C'
      this.area.sigla = ''
      this.area.idRepresenta = '0'
      this.area.idPersona = '0'
      this.area.nombres = ''
      this.area.apePaterno = ''
      this.area.apeMaterno = ''
      this.area.flagActivo = '1'
      this.isEditMode = true; // Deshabilitar el modo de edición en el campo Sigla

      // Verificando si el área es nueva antes de llamar a crearSigla
      if (this.area.idArea === '0') {
        // Llamando al Método para crear la Sigla solo cuando es un nuevo registro
        this.crearSigla();
      }

    },
    cargarUsuarios() {
      axios.get(
        //'https://tomcat.sedetc.gob.pe/cas-services-0.0.2/usuarios/*'
        `${apiURL}/usuarios/*`
      ).then(response => {
        this.usuarios = response.data
        //console.log('--- usuarios', this.usuarios);
      })
        .catch(error => {
          if (error.response && error.response.status === 401) {
            App.methods.logout.call(this);
          }
        })
    },
    selectPersonal() {
      if (this.selectedIdPersonal && this.selectedIdPersonal.idTrabajador) {
        const newId = this.selectedIdPersonal.idTrabajador;

        // Busca el usuario seleccionado en el arreglo de usuarios
        const selectedUser = this.usuarios.find(u => u.idTrabajador === newId) || {};
        // Actualiza los campos deseados en el área según el usuario seleccionado 
        this.area.idPersona = selectedUser.idTrabajador || '0';
        this.area.nombres = selectedUser.nombres || '';
        this.area.apePaterno = selectedUser.apePaterno || '';
        this.area.apeMaterno = selectedUser.apeMaterno || '';
        this.area.idRepresenta = selectedUser.idTrabajador || '0';
        // Actualiza el usuario seleccionado
        this.usuarioSeleccionado = selectedUser;
        //console.log('Usuario seleccionado:', this.usuarioSeleccionado);
      } else {
        //console.warn('selectedIdPersonal es null o no tiene idTrabajador');
        //this.usuarioSeleccionado = {};
        this.usuarioSeleccionado = {
          idTrabajador: '0',
          nombres: '',
          apePaterno: '',
          apeMaterno: '',
        };
        //console.log('this.usuarioSeleccionado', this.usuarioSeleccionado)

        // Actualiza con datos vacíos en this.área
        this.area.idPersona = this.usuarioSeleccionado.idTrabajador || '0';
        this.area.nombres = this.usuarioSeleccionado.nombres || '';
        this.area.apePaterno = this.usuarioSeleccionado.apePaterno || '';
        this.area.apeMaterno = this.usuarioSeleccionado.apeMaterno || '';
        this.area.idRepresenta = this.usuarioSeleccionado.idTrabajador || '0';
      }
    },

    //Para convertir en mayúscula el texto ingresado en cajas
    formatToUpperCase(property, event) {
      this.area[property] = event.target.value.toUpperCase();
    },
    // Se crea la sigla automáticamente con las 1ras letras de cada palabra en el campo Descripción
    crearSigla() {
      // Obtener las primeras letras de cada palabra en el campo Descripción
      const palabras = this.area.descripcion.split(' ');
      this.area.sigla = palabras.map(palabra => palabra.charAt(0).toUpperCase()).join('');

      const MAX_CARACTERES = 10; // Definir el límite máximo de caracteres
      // Verificar si la longitud excede el límite
      if (this.area.sigla.length > MAX_CARACTERES) {
        // Truncar la sigla a la longitud máxima permitida
        this.area.sigla = this.area.sigla.slice(0, MAX_CARACTERES) + '';
        // Mostrar el mensaje de límite
        this.mensajeLimiteSigla = `⚠️ Límite máximo de ${MAX_CARACTERES} caracteres para la Sigla`;
      } else {
        this.mensajeLimiteSigla = '';
      }
    },
    // Unir los dos métodos anteriores para usarse en el campo Descripción
    handleDescripcionInput(event) {
      // Llamando al Método para convertir a mayúsculas
      this.formatToUpperCase('descripcion', event);
      // Llamando al Método para crear la Sigla, solo cuando se está creando un nuevo registro
      if (this.area.idArea === '0') {
        this.crearSigla();
      }
    },
    verificarLimiteSigla() {
      const MAX_CARACTERES = 10; // Definir el límite máximo de caracteres      
      // Obtener la sigla sin espacios en blanco al inicio y al final
      const siglaSinEspacios = this.area.sigla.trim();
      // Verificar si la longitud excede el límite
      if (siglaSinEspacios.length > MAX_CARACTERES) {
        // Truncar la sigla a la longitud máxima permitida
        this.area.sigla = siglaSinEspacios.slice(0, MAX_CARACTERES);
        // Mostrar el mensaje de límite
        this.mensajeLimiteSigla = `⚠️ Límite máximo de ${MAX_CARACTERES} caracteres para la Sigla`;
      } else {
        this.mensajeLimiteSigla = '';
      }
    },
    ///Eliminar espacios en blanco y algunos caracteres especiales
    removeSpacesAndSpecialChars(property) {
      //this.area[property] = this.area[property].replace(/\s/g, '');
      // Eliminar espacios en blanco y caracteres no deseados (permitir solo letras, números y algunos especiales)
      this.area[property] = this.area[property].replace(/[^A-Za-z0-9_\-\.]/g, '');
    },
    //Combinar 3 eventos en la campo Sigla
    handleSiglaInput(event) {
      // Convertir a mayúsculas y verificar límite de caracteres
      this.formatToUpperCase('sigla', event);
      // Eliminar espacios en blanco y caracteres no deseados en el campo Sigla
      this.removeSpacesAndSpecialChars('sigla');
      this.verificarLimiteSigla();
    },

    //// Método para anular un usuario según el idArea (areaxusuario)
    anularUsuByArea: function (array) {
      this.array.idUsuario = array.idUsuario
      this.array.idAreaXUsu = array.idAreaXUsu
      axios.post(
        `${apiURL}/operaciones/areaByUsu/add`,
        {
          'idAreaXUsu': this.array.idAreaXUsu,
          'idUsuario': this.array.idUsuario,
          'flagActivo': '0',
          'usuario': this.$session.get('user')
        }
      ).then(response => {
        this.error3 = response.data
      })
        .catch(error => {
          if (error.response && error.response.status === 401) {
            App.methods.logout.call(this);
          }
        })
    },
    alertaError() {
      Swal.fire({
        icon: 'error',
        title: 'Usuario No Autorizado',
        text: 'No tienes permisos para acceder.',
        timer: 2000, // Duración en milisegundos
        timerProgressBar: true,
        showConfirmButton: false
      }).then(() => {
        // Se redirecionará a la vista anterior
        this.$router.go(-1);
      });
    },
    alertaError401() {
      Swal.fire({
        icon: 'error',
        title: 'La sesión ha expirado',
        //text: 'Vuelve a iniciar sesión.',
        footer: '<a href="#">Vuelve a iniciar sesión.</a>',
        timer: 3000, // Duración en milisegundos
        timerProgressBar: true,
        showConfirmButton: false
      }).then(() => {
        //this.$router.go(-1);
        //this.$session.destroy()
        //this.$router.push('/login')
        App.methods.logout.call(this); ///Cierra la sesión         
      });
    },
    alertaError500() {
      Swal.fire({
        icon: 'error',
        title: 'Error interno del servidor',
        text: 'Ocurrió un error. Por favor, inténtalo de nuevo más tarde..',
        timer: 5000, // Duración en milisegundos
        timerProgressBar: true,
        showConfirmButton: false
      }).then(() => {
        this.$router.go(-1);
      });
    },
    ////Guardar la descripcion del Área en el store
    enviar(item) {
      localStorage.setItem('idArea', item.idArea)
      localStorage.setItem('desArea', item.descripcion)      
      this.$router.push('/areas');
    }
  },
  computed: {
    filteredUsuarios() {
      const lowerSearchText = this.searchText.toLowerCase();
      //console.log('..this.usuarios', this.usuarios);
      return this.usuarios.map(usu => {
        // Verificamos que usu sea un objeto y tenga las propiedades necesarias
        if (usu && usu.nombres && usu.apePaterno && usu.apeMaterno) {
          return {
            ...usu,
            //idTrabajador: usu.idTrabajador,  ///incluir la propiedad idTrabajador
            nombreCompleto: `${usu.nombres} ${usu.apePaterno} ${usu.apeMaterno}`
          };
        }
        return null;
      }).filter(usu => usu && (
        usu.nombres.toLowerCase().includes(lowerSearchText) ||
        usu.apePaterno.toLowerCase().includes(lowerSearchText) ||
        usu.apeMaterno.toLowerCase().includes(lowerSearchText)
      ));
    },
  },
}

</script>

<style>
table.dataTable thead .sorting:after,
table.dataTable thead .sorting_asc:after,
table.dataTable thead .sorting_desc:after {
  font-family: 'FontAwesome';
}

table.dataTable thead .sorting:after {
  content: "\f0dc";
}

table.dataTable thead .sorting_asc:after {
  content: "\f0dd";
}

table.dataTable thead .sorting_desc:after {
  content: "\f0de";
}

.combobox-personalizado2 {
  padding: 0%;
  margin-left: 12px;
  width: 570px;
  font-size: 14px;
  /* font-weight: bold;*/
  font-family: "Arial";
  color: black;
}

@media (max-width: 767px) {
  .combobox-personalizado2 {
    width: 342px; /* Establece el ancho al 100% en dispositivos con un ancho de pantalla menor o igual a 767px */
    max-width: none; 
    font-size: 12px;
  }
}

.representante-container {
  margin-left: -12px;
}

.representante-label {
  margin-left: 15px;
}
</style>



// WEBPACK FOOTER //
// Areas.vue?031636c5